import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeSearchList } from '../searchThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'bikeSearch';

export const bikeSearchSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: builder => {
        handleRequestThunk({ builder, request: getBikeSearchList });
    },
});

export const bikeSearch = bikeSearchSlice.reducer;
